import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { formatLocale } from '../../utils';
import { availableLanguages, defaultLanguage } from '../../constants/configuration';

export interface ILangState {
  availableLanguages: string[];
  selectedLanguage: string;
}

const initialState: ILangState = {
  availableLanguages,
  selectedLanguage: !availableLanguages.includes(localStorage.getItem('i18nextLng') ?? '')
    ? defaultLanguage
    : localStorage.getItem('i18nextLng') || defaultLanguage,
};

export const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    selectLanguage(state, action: PayloadAction<string>) {
      const selectedLanguage = !availableLanguages.includes(action.payload) ? defaultLanguage : action.payload;
      state.selectedLanguage = selectedLanguage;
      localStorage.setItem('i18nextLng', formatLocale(selectedLanguage));
    },
  },
});

export default langSlice.reducer;
